import { record, upper, type Row, type StatusRow } from '../ability/context.js';
import { readItemField } from '../compile/item-field-reader.js';
import { normalizePhpListish } from '../../shared/php-listish.js';
import type { AppliedFrameResult } from './applied-frame.js';

/** Carry only missing raw status inputs. Held encounter definitions already reach every receiver. */
export function withStatusFrameInputs(frame: AppliedFrameResult, statuses: readonly StatusRow[], encounter: Row | null,
  definition?: (id: string) => Row | null): AppliedFrameResult {
  if ('cache_ref' in frame || !statuses.length || !encounter) return frame;
  const rawCatalog = (host: Row): Row | null => record(record(record(host._entity_base)?.base)?.catalog);
  const held = rawCatalog(encounter);
  const rawDefinition = (host: Row, id: string): Row | null => {
    const row = record(rawCatalog(host)?.[id]);
    return row && record(row.items) && upper(readItemField(row, 'item_id')) === id ? row : null;
  };
  let members: Row[] | undefined;
  for (const id of new Set(statuses.map(s => upper(s.status_item_id)))) {
    if (record(held?.[id]) || record(record(frame.inputs?.catalog)?.[id])) continue;
    // A newly selected GM status may be held as its own adopted object before
    // the encounter has ever carried it. Borrow that object's SELECT inputs;
    // its compiled display definition must never enter the raw frame catalog.
    const selected = definition?.(id);
    let row = selected ? rawDefinition(selected, id) : null;
    if (!row) {
      members ??= normalizePhpListish(encounter.encounter_creatures_arr).map(record).filter((row): row is Row => row !== null);
      for (const member of members) { row = rawDefinition(member, id); if (row) break; }
    }
    if (!row) continue;
    (frame.inputs ??= {}).catalog ??= {};
    (frame.inputs.catalog as Row)[id] = row;
  }
  return frame;
}
